import React from 'react';
import PropTypes from 'prop-types';

import {frefFromRef} from '../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../react-oe/oe-interface-adapter';
import OEIcon from '../elements/oe-icon';
import OEButton from '../elements/controls/oe-button';
import OEIconCodes from '../../lib/oe-icon-codes';
import OEStdModalController from '../modals/oe-std-modal-controller';
import {OEBlurLayer, OEBlurModalBackdropLayer} from './oe-blur-layer';
import OEPDFView from '../elements/pdf-view/oe-pdf-view';
import retardUpdate from '../../lib/react/update-retarder';

export class OEPDFModal extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.options = this.props.options;

        this.state = {
            title: this.createTitle(),
            pdfURL: this.createPDFURL(),
            downloadName: this.createDownloadName()
        };

        this.onLanguageChanged = this.onLanguageChanged.bind(this);

        this.renderAdditionalButtons = this.renderAdditionalButtons.bind(this);

        this.onOptionsChanged = this.onOptionsChanged.bind(this);

        this.onDownloadBtnPressed = this.onDownloadBtnPressed.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.onLanguageChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.onLanguageChanged);
    }

    onLanguageChanged() {
        this.updateLanguage();
    }

    createTitle()  {
        let title;
        if(this.options)    {
            if(this.options.titleID && this.oe.isReady())    title = this.oe.sharedInterface.getLocalizedStringEnc(this.options.titleID);
            if((!title || title === '#null') && this.options.title) title = this.options.title;
        }
        return title;
    }

    updateTitle() {
        this.setState({title: this.createTitle()});
    }

    createPDFURL()  {
        let pdfURL;
        if(this.options)    {
            if(this.options.pdfURL_ID && this.oe.isReady())    pdfURL = this.oe.sharedInterface.getLocalizedStringEnc(this.options.pdfURL_ID);
            if((!pdfURL || pdfURL === '#null') && this.options.pdfURL) pdfURL = this.options.pdfURL;
        }
        return pdfURL;
    }

    updatePDFURL() {
        this.setState({pdfURL: this.createPDFURL()});
    }

    createDownloadName()   {
        let downloadName;
        if(this.options)    {
            if(this.options.downloadNameID && this.oe.isReady())    downloadName = this.oe.sharedInterface.getLocalizedStringEnc(this.options.downloadNameID);
            if((!downloadName || downloadName === '#null') && this.options.downloadName) downloadName = this.options.downloadName;
        }
        return downloadName ? downloadName : 'explorer';
    }

    updateDownloadName() {
        this.setState({downloadName: this.createDownloadName()});
    }

    updateLanguage()   {
        this.updateTitle();
        this.updatePDFURL();
        this.updateDownloadName();
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
        });
    }

    renderAdditionalButtons(props)  {
        return (
            <React.Fragment>
                <OEButton
                    className="btn download-btn"
                    onPressed={this.onDownloadBtnPressed}>
                    <OEIcon code={OEIconCodes.download} />
                </OEButton>
            </React.Fragment>
        );
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OEStdModalController
                    className="simple-header clear-backdrop flow-nav-modal pdf-modal center"
                    moduleId={this.props.moduleId}
                    zIndex={this.props.zIndex}
                    title={this.state.title}
                    hasCloseBtn={true}
                    isOpen={this.props.isOpen}
                    keyboard={this.props.keyboard}
                    onOpenStateChanged={this.props.onOpenStateChanged}
                    onOptionsChanged={this.onOptionsChanged}
                    onToggle={this.props.onToggle}
                    options={this.props.options}
                    additionalButtons={this.props.downloadBtn && this.state.pdfURL ? this.renderAdditionalButtons : null}
                    ref={this.props.fref}
                >
                    {!this.state.pdfURL ? null :
                        <OEPDFView 
                            fileURL={this.state.pdfURL}
                            page={Math.max(typeof(this.props.page) === 'number' ? this.props.page : 1, 1)}
                            layoutToPageHeight={true}
                        />
                    }

                    <OEBlurModalBackdropLayer/>
                    <OEBlurLayer apply={true} ruleName={'blur-manual-view-modal-backdrop'} selector={'body .blur-by-manual-view'}/>
                </OEStdModalController>
            </React.Fragment>
        );
    }

    onOptionsChanged(sender, options)  {
        this.options = options;
        this.updateTitle();
        this.updatePDFURL();
        this.updateDownloadName();
    }

    onDownloadBtnPressed()  {
        let link = document.createElement('a');
        link.download = this.state.strings.downloadName + '.pdf';
        link.href = this.state.pdfURL;
        link.click();
    }
}

OEPDFModal.defaultProps = {
    moduleId:               '',
    zIndex:                 1050,
    keyboard:               true,
    downloadBtn:            false,
    downloadName:           'explorer'
};

OEPDFModal.propTypes = {
    moduleId:               PropTypes.string,
    zIndex:                 PropTypes.number,
    isOpen:                 PropTypes.bool,
    keyboard:               PropTypes.bool,
    onOpenStateChanged:     PropTypes.func,
    onToggle:               PropTypes.func,
    options: PropTypes.shape({
        title:              PropTypes.string,
        titleID:            PropTypes.string,
        pdfURL:             PropTypes.string,
        pdfURL_ID:          PropTypes.string,
        downloadBtn:        PropTypes.bool,
        downloadName:       PropTypes.string,
        downloadNameID:     PropTypes.string
    })
};

export default frefFromRef(OEPDFModal);